export default "__VITE_ASSET__Bne4dojC__"